import { useState } from "react";
import { toast } from "sonner";
import { Hourglass, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { LegalCountdown } from "./LegalCountdown";
import { LegalTimerFields, EMPTY_TIMER } from "./LegalTimerFields";
import { errMsg } from "./legalUtils";

export const LegalTimerCard = ({ c, canEdit, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [t, setT] = useState(EMPTY_TIMER);
  const [busy, setBusy] = useState(false);
  if (!c.timer && (!canEdit || c.status === "closed")) return null;
  const open = () => { setT(c.timer ? { ...EMPTY_TIMER, ...c.timer } : EMPTY_TIMER); setEdit(true); };
  const save = async (clear) => {
    if (!clear && !t.deadline) { toast.error("حدد موعد المؤقت"); return; }
    setBusy(true);
    try { await api.legalSetTimer(c.id, clear ? { deadline: "" } : t); toast.success(clear ? "تم إلغاء المؤقت" : "تم ضبط المؤقت ✅"); setEdit(false); onSaved(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 rounded-2xl border border-slate-200 bg-white p-3" data-testid="legal-timer-card">
      {c.timer && <LegalCountdown timer={c.timer} testId="legal-case-countdown" />}
      {c.timer && <p className="text-[11px] text-slate-500">تنبيه واتساب قبل الموعد بـ: {c.timer.alert_days.map((d) => (d === 0 ? "عند الانتهاء" : `${d} يوم`)).join("، ")}{(c.timer.sent || []).length ? ` · أُرسل: ${c.timer.sent.length}` : ""}</p>}
      {canEdit && c.status !== "closed" && !edit && (
        <Button size="sm" variant="outline" className="gap-1.5" onClick={open} data-testid="legal-timer-edit"><Hourglass className="h-3.5 w-3.5" /> {c.timer ? "تعديل المؤقت" : "إضافة مؤقت زمني"}</Button>
      )}
      {edit && (
        <div className="space-y-2">
          <LegalTimerFields t={t} onChange={setT} />
          <div className="flex gap-2">
            <Button size="sm" onClick={() => save(false)} disabled={busy} data-testid="legal-timer-save">{busy && <Loader2 className="me-1 h-3.5 w-3.5 animate-spin" />}حفظ المؤقت</Button>
            {c.timer && <Button size="sm" variant="ghost" className="text-rose-600" onClick={() => save(true)} disabled={busy} data-testid="legal-timer-clear">إلغاء المؤقت</Button>}
            <Button size="sm" variant="ghost" onClick={() => setEdit(false)}>رجوع</Button>
          </div>
        </div>
      )}
    </div>
  );
};
